import { render, staticRenderFns } from "./orgCheckConfigList.vue?vue&type=template&id=299b521e&scoped=true"
import script from "./orgCheckConfigList.vue?vue&type=script&lang=js"
export * from "./orgCheckConfigList.vue?vue&type=script&lang=js"
import style0 from "./orgCheckConfigList.vue?vue&type=style&index=0&id=299b521e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b521e",
  null
  
)

export default component.exports